import { useEffect } from 'react';

import type { TrackClickstreamEventFn } from '../../utils/ClickstreamEvents';
import {
  CLICK_WIDGET_EDIT_ADDRESS,
  CLICK_WIDGET_EDIT_PERSONAL_INFORMATION,
  CLICK_WIDGET_GET_QUOTE,
  CLICK_WIDGET_REVIEW_COVERAGES,
} from '../../utils/ClickstreamEvents';

import { HomesiteConstants } from '../../constants';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'embedded-sales-module': {
        addressline1?: string;
        city?: string;
        email?: string;
        firstname?: string;
        lastname?: string;
        returnredirecturl?: string;
        state?: string;
        utm?: string;
        zip: string;
        children?: React.ReactNode;
      };
    }
  }
}

type EmbeddedWidgetProps = {
  city?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  params?: string;
  state?: string;
  street?: string;
  zip: string;
  onClose: () => void;
  trackClickstreamEvent: TrackClickstreamEventFn;
};

const EmbeddedWidget = ({
  city,
  email,
  firstName,
  lastName,
  params,
  state,
  street,
  zip,
  onClose,
  trackClickstreamEvent,
}: EmbeddedWidgetProps) => {
  useEffect(() => {
    const EmbeddedWidgetElement = document.querySelector('embedded-sales-module');
    EmbeddedWidgetElement?.addEventListener('click', onClickModuleButtons);
    EmbeddedWidgetElement?.addEventListener('review-coverages', onReviewCoverages);

    return () => {
      EmbeddedWidgetElement?.removeEventListener('click', onClickModuleButtons);
      EmbeddedWidgetElement?.removeEventListener('review-coverages', onReviewCoverages);
    };
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onClickModuleButtons = (event: any) => {
    if (event.target.id === HomesiteConstants.WIDGET_BUTTON_IDS.GET_QUOTE) {
      trackClickstreamEvent(CLICK_WIDGET_GET_QUOTE);
    } else if (event.target.id === HomesiteConstants.WIDGET_BUTTON_IDS.EDIT_ADDRESS) {
      trackClickstreamEvent(CLICK_WIDGET_EDIT_ADDRESS);
    } else if (event.target.id === HomesiteConstants.WIDGET_BUTTON_IDS.EDIT_ABOUT_YOU) {
      trackClickstreamEvent(CLICK_WIDGET_EDIT_PERSONAL_INFORMATION);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onReviewCoverages = (event: any) => {
    const {
      detail: { url },
    } = event;

    trackClickstreamEvent(CLICK_WIDGET_REVIEW_COVERAGES);
    window.open(url, '_blank');
    onClose();
  };

  return (
    <embedded-sales-module
      data-testid="embedded-widget"
      addressline1={street}
      city={city}
      email={email}
      firstname={firstName}
      lastname={lastName}
      returnredirecturl="true"
      state={state}
      utm={params}
      zip={zip}
    ></embedded-sales-module>
  );
};

export default EmbeddedWidget;
